(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anyway-buybox"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio' || !radio.classList.contains('aw-tierb__radio')) return;
    const form = radio.closest('form');
    if (!form) return;
    const variantInput = form.querySelector('[data-aw-variant]');
    const planInput = form.querySelector('[data-aw-plan]');
    const priceLabel = form.querySelector('[data-aw-submit-price]');
    if (variantInput) variantInput.value = radio.value;
    if (planInput) {
      const plan = radio.dataset.plan || '';
      planInput.value = plan;
      planInput.disabled = plan === '';
    }
    if (priceLabel && radio.dataset.price) priceLabel.textContent = radio.dataset.price;
  });

  document.addEventListener('click', (event) => {
    const thumb = event.target instanceof Element ? event.target.closest('[data-aw-thumb]') : null;
    if (!thumb) return;
    const hero = document.getElementById('aw-buybox-hero');
    if (!hero) return;
    hero.removeAttribute('srcset');
    hero.src = thumb.dataset.awThumb;
    thumb.closest('.aw-buybox__rail')?.querySelectorAll('.aw-buybox__thumb').forEach((t) => t.classList.toggle('is-active', t === thumb));
  });

  function anywayBuyboxBoot() {
    document.querySelectorAll('.aw-buybox__form').forEach((form) => {
      const checked = form.querySelector('.aw-tierb__radio:checked') || form.querySelector('.aw-tierb__radio:not(:disabled)');
      if (!checked) return;
      checked.checked = true;
      checked.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  document.addEventListener('DOMContentLoaded', anywayBuyboxBoot);
  document.addEventListener('shopify:section:load', anywayBuyboxBoot);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anyway-dose-finder"] && !Shopify.designMode) return;
  try {
    
  function anywayFinderInit(panel) {
    const food = panel.querySelector('[data-aw-finder-food]');
    const count = panel.querySelector('[data-aw-finder-count]');
    const dose = panel.querySelector('[data-aw-finder-dose]');
    const detail = panel.querySelector('[data-aw-finder-detail]');
    if (!food || !count || !dose) return;

    const perTablet = parseFloat(String(panel.dataset.gramsPerTablet).replace(',', '.')) || 12;
    const threshold = parseFloat(String(panel.dataset.threshold).replace(',', '.')) || 2;
    const nf = new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 1 });

    function update() {
      const grams = (parseFloat(String(food.value).replace(',', '.')) || 0) * (parseInt(count.value, 10) || 1);
      const note = food.selectedOptions[0] ? food.selectedOptions[0].dataset.note : '';

      let text;
      if (grams < threshold) {
        text = panel.dataset.noneText;
      } else {
        const halves = Math.ceil((grams / perTablet) * 2) / 2;
        if (halves <= 0.5) text = panel.dataset.halfText;
        else if (halves === 1) text = panel.dataset.oneText;
        else text = panel.dataset.manyText.replace('[n]', nf.format(halves));
      }
      dose.textContent = text;
      if (detail) {
        const lactose = panel.dataset.lactoseLabel.replace('[g]', nf.format(grams));
        detail.textContent = note ? lactose + ' ' + note : lactose;
      }
    }

    food.addEventListener('change', update);
    count.addEventListener('input', update);
    panel.querySelectorAll('[data-aw-finder-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const next = (parseInt(count.value, 10) || 1) + parseInt(button.dataset.awFinderStep, 10);
        count.value = String(Math.min(10, Math.max(1, next)));
        update();
      });
    });
    update();
  }

  function anywayFinderBoot() {
    document.querySelectorAll('[data-aw-finder]').forEach(anywayFinderInit);
  }

  document.addEventListener('DOMContentLoaded', anywayFinderBoot);
  document.addEventListener('shopify:section:load', anywayFinderBoot);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anyway-offer-ladder"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio' || !radio.classList.contains('aw-tier__radio')) return;
    const form = radio.closest('form');
    if (!form) return;
    const variantInput = form.querySelector('[data-aw-variant]');
    const planInput = form.querySelector('[data-aw-plan]');
    const priceLabel = form.querySelector('[data-aw-submit-price]');
    if (variantInput) variantInput.value = radio.value;
    if (planInput) {
      const plan = radio.dataset.plan || '';
      planInput.value = plan;
      planInput.disabled = plan === '';
    }
    if (priceLabel && radio.dataset.price) priceLabel.textContent = radio.dataset.price;
  });

  document.addEventListener('click', (event) => {
    const thumb = event.target instanceof Element ? event.target.closest('[data-aw-thumb]') : null;
    if (!thumb) return;
    const hero = document.getElementById('aw-hero-img');
    if (!hero) return;
    hero.removeAttribute('srcset');
    hero.src = thumb.dataset.awThumb;
  });

  function anywayLadderBoot() {
    document.querySelectorAll('.aw-ladder').forEach((form) => {
      const checked = form.querySelector('.aw-tier__radio:checked') || form.querySelector('.aw-tier__radio:not(:disabled)');
      if (!checked) return;
      checked.checked = true;
      checked.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  document.addEventListener('DOMContentLoaded', anywayLadderBoot);
  document.addEventListener('shopify:section:load', anywayLadderBoot);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anyway-review-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const tab = event.target.closest && event.target.closest('[data-aw-tab]');
    if (!tab) return;
    const root = tab.closest('.aw-wrap');
    if (!root) return;
    const key = tab.dataset.awTab;
    root.querySelectorAll('[data-aw-tab]').forEach((t) => t.classList.toggle('is-active', t === tab));
    root.querySelectorAll('[data-aw-tab-group]').forEach((item) => {
      item.hidden = key !== '' && item.dataset.awTabGroup !== key;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anyway-sticky-buy"] && !Shopify.designMode) return;
  try {
    
  /* Horizon scrolls `.page-wrapper` on desktop, not the window, so a scroll listener on
     window never fires above 990px. Watching the buy box itself works on both. */
  class AnywayStickyBuy extends HTMLElement {
    connectedCallback() {
      const target =
        document.getElementById('aw-buy') ||
        document.querySelector('.aw-buybox') ||
        document.querySelector('.aw-ladder');

      if (!target) {
        this.dataset.visible = 'false';
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.dataset.visible = scrolledPast ? 'true' : 'false';
          }
        },
        { threshold: 0, rootMargin: '0px' }
      );
      this.observer.observe(target);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }
  if (!customElements.get('aw-sticky-buy')) customElements.define('aw-sticky-buy', AnywayStickyBuy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anyway-value-calculator"] && !Shopify.designMode) return;
  try {
    
  function anywayCalcInit(panel) {
    const nf = new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const symbol = panel.dataset.currency || '€';
    const num = (value) => parseFloat(String(value == null ? '' : value).replace(',', '.')) || 0;
    const rates = {
      milk: num(panel.dataset.milkPremium),
      items: num(panel.dataset.itemPremium),
      skips: num(panel.dataset.skipValue),
    };
    const productYear = num(panel.dataset.productYear);
    const inputs = panel.querySelectorAll('[data-aw-input]');
    const totalOut = panel.querySelector('[data-aw-output="total"]');
    const verdict = panel.querySelector('[data-aw-output="verdict"]');

    function update() {
      let total = 0;
      inputs.forEach((input) => {
        const key = input.dataset.awInput;
        const value = parseFloat(input.value) || 0;
        const mirror = panel.querySelector('[data-aw-output="' + key + '"]');
        if (mirror) mirror.textContent = value;
        total += key === 'skips' ? value * rates[key] * 12 : value * rates[key] * 52;
      });
      if (totalOut) totalOut.textContent = symbol + nf.format(Math.round(total));
      if (verdict) {
        const diff = total - productYear;
        verdict.textContent = diff > 0
          ? 'Dat is ' + symbol + nf.format(Math.round(diff)) + ' per jaar meer dan de tabletten kosten.'
          : '';
      }
    }

    inputs.forEach((input) => input.addEventListener('input', update));
    update();
  }

  function anywayCalcBoot() {
    document.querySelectorAll('[data-aw-calc]').forEach(anywayCalcInit);
  }

  document.addEventListener('DOMContentLoaded', anywayCalcBoot);
  document.addEventListener('shopify:section:load', anywayCalcBoot);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
